import { intersect, partial, string, struct, union } from 'io-ts/Decoder';

import { ComplexId as ExistingFileComplexId } from '../../../file/ComplexId';
import { Type as PagesToCompare } from '../../../fpc/pages-to-compare/Type';
import { RequestItem as NewFile } from '../../file/create';

export const Request = intersect(
	struct({
		name: string,
		//
		pagesToCompare: PagesToCompare,
		//
		originalFile: union(NewFile, ExistingFileComplexId),
		variationFile: union(NewFile, ExistingFileComplexId),
	})
)(
	partial({
		originalFileLabel: string,
		variationFileLabel: string,
	})
);
